export const SEARCH_TYPE_ORDER = "order";
export const SEARCH_TYPE_INVOICE = "invoice";
export const UOM_E_MULT = 1;
export const UOM_C_MULT = 100;
export const UOM_M_MULT = 1000;
export const UOM_MAP  = {
    EA: UOM_E_MULT,
    E: UOM_E_MULT,
    C: UOM_C_MULT,
    M: UOM_M_MULT
};